// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { truncate } from 'Components/utils/string/string.util';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import * as CARD_LAYOUTS from 'Components/frameworks/card/Card.constants';

import { Card } from 'Components/frameworks/card/Card.jsx';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import Image from 'Components/frameworks/image/Image.jsx';

type Props = {
  offers: Array<{
    color?: string,
    commercialArgument?: string,
    description?: string,
    href?: string,
    id?: string,
    image?: string,
    legalInformation?: string,
    name?: string,
    timingArgument?: string,
  }>,
  textLimit?: number,
};

export function OffersGrid(props: Props) {
  const { offers = [], textLimit = 250 } = props;
  const { isTablet } = useContext(ResponsiveContext);

  if (!offers.length) {
    return null;
  }

  return (
    <section className="sm:flex flex-wrap">
      {offers.map((offer = {}) => {
        const {
          color = 'black',
          commercialArgument,
          description = '',
          href,
          id,
          image,
          name = '',
        } = offer;

        const truncatedText = textLimit > 0 ? truncate(description, textLimit) : description;

        const classNames = isTablet
          ? 'decorator-border-grid pt-8 px-3 pb-12 w-1/2'
          : 'decorator-border-bottom-list py-5';

        return (
          <div className={classNames} key={id}>
            <div className="m-auto" style={{ maxWidth: '23.75rem' }}>
              <Card
                ctaLabel={name}
                customMedia={
                  image ? (
                    <DynamicLink
                      className="block flex leading-none m-0 no-underline"
                      data-testid="OffersGrid-captionLink"
                      url={href}
                    >
                      <Image
                        className="w-7/10"
                        imageUrl={image}
                        mandatoryWidthAndHeight={{
                          w: 250,
                          h: 250 * ratioUtils.values[ratioUtils.S],
                        }}
                      />
                      <span
                        className="flex font-bold items-center leading-one no-underline p-1 text-center text-lg text-white uppercase w-3/10"
                        data-testid="OffersGrid-captionLink-caption"
                        style={{ backgroundColor: color, wordWrap: 'break-word' }}
                      >
                        {commercialArgument}
                      </span>
                    </DynamicLink>
                  ) : null
                }
                heading={{ title: name }}
                {...(id ? { id } : null)}
                layout={CARD_LAYOUTS.COLUMN_2}
                link={{ url: href }}
                text={{ text: truncatedText }}
                theme="landing"
              />
            </div>
          </div>
        );
      })}
    </section>
  );
}
